/** @format */

import {Box} from '@mui/material';

import {Trans} from 'react-i18next';

import {Text, Wrapper} from './styles';

import bottomBanner from './images/banner_bottom.svg';
import topBanner from './images/banner_top.svg';
import iconLight from './images/icon_light.svg';

const Banner = () => {
  return (
    <Wrapper>
      <Text sx={{mb: 4}}>
        <Trans>Выбранные цели будут доступны для построения графиков на Цифровом слепке.</Trans>
      </Text>
      <img alt='Top banner' src={topBanner} />
      <Box sx={{display: 'flex', mt: 8, mb: 4}}>
        <img src={iconLight} alt='Icon light' />
        <Box>
          <Text>
            <Trans>
              Располагайте очередность шагов в соответствии с воронкой взаимодействия с клиентом.
            </Trans>
          </Text>
          <Text>
            <Trans>Приоритетную цель указывайте последней.</Trans>
          </Text>
        </Box>
      </Box>
      <img alt='Bottom banner' src={bottomBanner} />
    </Wrapper>
  );
};

export default Banner;
